import { Typography } from '@sravni/react-design-system';
import React from 'react';

import { LottieLoader } from 'shared/ui/lottie.loader';

import { INVESTIGATE_CH_TEXT } from 'features/SlidesLoader/config';

import animationData from '../../config/animations/scoring.json';

import styles from './styles.module.scss';

export const ScoringLoad: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <LottieLoader
        className={styles.imageContainer}
        options={{ animationData }}
        height={160}
      />
      <Typography.Heading
        className={styles.heading}
        level={4}
      >
        {INVESTIGATE_CH_TEXT}
      </Typography.Heading>
    </div>
  );
};
